import { useTranslation } from "react-i18next";

import { COMMUNICATION_EVENTS, KEYLOCKER_COMMUNICATION_EVENT_TYPE } from "models";

export const useCustomerCommunicationTypes = (): Record<COMMUNICATION_EVENTS, string> => {
  const { t } = useTranslation();

  return {
    [COMMUNICATION_EVENTS.OnlineCheckInSent]: t("v8_online_check_in", "Online check-in"),
    [COMMUNICATION_EVENTS.OnlineCheckInOpened]: "",
    [COMMUNICATION_EVENTS.OnlineCheckInAnswered]: t("v8_online_check_in_confirmation", "Online check-in confirmation"),
    [COMMUNICATION_EVENTS.DiagnoseOverviewSent]: t("v8_new_diagnose_overview", "New diagnose overview"),
    [COMMUNICATION_EVENTS.DiagnoseOverviewOpened]: "",
    [COMMUNICATION_EVENTS.DiagnoseOverviewAnswered]: t("v8_diagnose_overview_confirmation", "Diagnose overview confirmation"),
    [COMMUNICATION_EVENTS.DiagnoseOverviewResent]: t("v8_updated_diagnose_overview", "Updated diagnose overview"),
    [COMMUNICATION_EVENTS.RepairOverviewSent]: t("v8_new_repair_overview", "New repair overview"),
    [COMMUNICATION_EVENTS.RepairOverviewResent]: t("v8_updated_repair_overview", "Updated repair overview"),
    [COMMUNICATION_EVENTS.RepairOverviewOpened]: ""
  };
};

export const useKeylockerCommunicationTypes = (): Record<KEYLOCKER_COMMUNICATION_EVENT_TYPE, string> => {
  const { t } = useTranslation();

  return {
    [KEYLOCKER_COMMUNICATION_EVENT_TYPE.DropPINSent]: t("v8_keylocker_check_in", "Keylocker check-in"),
    [KEYLOCKER_COMMUNICATION_EVENT_TYPE.CheckInOpened]: "",
    [KEYLOCKER_COMMUNICATION_EVENT_TYPE.CheckInAnswered]: "",
    [KEYLOCKER_COMMUNICATION_EVENT_TYPE.PickUpPINSent]: t("v8_keylocker_key_dropped_back", "Keylocker key dropped back")
  };
};
